import { useQuery } from "@tanstack/react-query";
import { fetchResource, queryKeys } from "../services/ReactQuery/reactQueryService";
import { HistoryEntityType, HistoryLogEntityMap } from "../types/HistoryLog";

const historyLogEntityUris: Record<HistoryEntityType, string> = {
  activity: "activities",
  beaMessage: "bea_messages",
  emailMessage: "email_messages",
  fax: "faxes",
  inquiryToCustomer: "inquiry_to_customers",
  mediaObject: "media_objects",
  message: "messages",
  note: "notes",
  paidTask: "paid_tasks",
};

export const getHistoryLogEntityUri = (entityType: HistoryEntityType): string => historyLogEntityUris[entityType];

export default function useHistoryLogEntity<TEntityType extends HistoryEntityType>(
  entityType: TEntityType,
  entityId: number | null,
  isExpanded: boolean,
) {
  const uri = getHistoryLogEntityUri(entityType);

  return useQuery<HistoryLogEntityMap[TEntityType]>({
    queryKey: queryKeys.item(uri, entityId ?? 0),
    queryFn: () => fetchResource(uri, entityId ?? 0),
    enabled: isExpanded && entityId !== null,
    retry: false,
  });
}
